import { FC } from "react";
import { ClientProps } from "../../../../hooks/useClientData";
import { Logitech_custom_Racing_meta } from "./Logitech_custom_Racing_meta";
import prizeLarge from "../../assets/logitech/10330.webp";

export const LogitechCustomLeaderboardIsEmpty: FC<{
  clientData: ClientProps;
}> = ({ clientData }) => {
  return (
    <div className="leaderboard__empty">
      <div className={`overview__content logitech_custom full `}>
        <section className="leaderboard content">
          <img src={prizeLarge} alt="" />
        </section>

        <section>
          <Logitech_custom_Racing_meta clientData={clientData} />
        </section>
      </div>
    </div>
  );
};
